module.exports = __webpack_public_path__ + "static/media/bg_introduction.46fcfeef.png";